module.exports = __webpack_public_path__ + "2acb60f2/img/revit-icon.5ff0d581.svg";